import React, {useEffect, useState, useRef} from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import {Video, Select} from '../components';
import { connect } from 'react-redux';
import axios from 'axios';


function ExtensionContent(props){
  const[list_id, setListId]=useState(localStorage.getItem('extension_list_id') || "");
  let first_time=useRef(true);

  if(first_time.current==true && props.lists==undefined && (props.me!=undefined && props.me!='unauthorised' && props.me.not_registered!=true)){props.index_lists(); first_time.current=false;}

  let list_data=[];
  if(props.lists!=undefined){
    console.log(props.lists, 'LISTS');
    for(let key in props.lists){
      let l=props.lists[key];
      list_data.push({value:l.id, name:l.name});
    }
  }


  return(
    <Grid container style={{width:'100%', height:'100%'}}>
    <Grid item xs={12}><div style={{position: 'relative',width: '100%',paddingTop: '40%',marginBottom: '0px'}}><Video style={{position: 'absolute',top: 0,left: 0,width: '100%',height: '100%'}} video={(props.me!=undefined && props.me!='unauthorised' && props.me.not_registered!=true)?"INTRO_EXTENSION":"INTRO_EXTENSION_OUT"} autoplay/></div></Grid>
    {(props.me!=undefined && props.me!='unauthorised' && props.me.not_registered!=true)?<Grid item xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
        <Select title='Default list' value={list_id} onChange={(e)=>{setListId(e.target.value); localStorage.setItem('extension_list_id', e.target.value); axios.post('/api/changeDefaultList/'+e.target.value);}} no_field style={{width:'calc(100% - 60px)', marginLeft:'10px', marginTop:'10px', backgroundColor:'#f7f9fc'}}  select_data={list_data}/>
    </Grid>:null}
    <Grid item xs={12} style={{display:'flex', justifyContent:'center', alignItems:'center'}}><Button variant='contained' color='secondary' onClick={()=>{window.open("https://app.prospectsafari.com", '_blank');}}>ProspectSafari</Button></Grid>
    </Grid>
  )
}




export default connect(ss, dd)(ExtensionContent);



function ss(state){
  return{
   default_list_id:state.lists.default,
   lists:state.lists.data
  }
}

function dd(dispatch){
  return{
    index_lists:()=>{dispatch({type:'REQUEST_LIST_INDEX'})}
  }
}
